module.exports = __webpack_public_path__ + "img/cow-face.d8ddf9ce.png";